//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { channelTypes } from '@motionelements/core/src/helpers/channelTypes';

export default {
  name: 'channel',
  layout: 'empty',
  components: {
    ChannelPage: () => import('@/components/channels/ChannelPage.vue'),
    ProductPage: () => import('@/components/ProductPage.vue'),
  },
  async asyncData({ params, store }) {
    const channel = channelTypes.find(({ link }) => link.includes(params.channel));
    if (channel) {
      const channelId = channel.id;
      store.dispatch('channels/setChannelType', channelId);
      return { channelId };
    }
  },
  data() {
    return {
      channelId: null,
    };
  },
  computed: {
    ...mapState({
      productId: state => state.product.id,
    }),
  },
  async fetch({ store, error }) {
    const productId = store.state.product.id;
    if (productId) {
      try {
        await store.dispatch('product/fetchProductSchema');
        await store.dispatch('product/fetchArchiveEntries', productId);
        // if (params.mediaType === 'stock-music') await store.dispatch('product/fetchStems', this.productId);
      } catch (err) {
        console.error(err);
      }
      try {
        await store.dispatch('product/fetchProduct', { id: productId }); // public info to render product page fast
      } catch (err) {
        console.error(err);
        error({ statusCode: _.get(err, 'response.status') || 500 });
      }
    }
  },
};
